<template>
  <v-container id="master-produksi-komoditas" fluid tag="section" class="cyber-container">
    <v-row>
      <v-col cols="12">
        <base-material-card color="#018C74" icon="mdi-sprout" class="glass-card">
          <template v-slot:heading>
            <div class="display-2 font-weight-black cyber-title">
              MODUL PRODUKSI KOMODITAS
            </div>
            <div class="subtitle-1 font-weight-light secondary-text">
              Manajemen Data Hasil Komoditas per Kecamatan
            </div>
          </template>

          <v-card-text class="mt-4">
            <v-row class="mb-6 align-center">
              <v-col cols="12" md="3">
                <v-btn class="cyber-btn-add" @click="openDialog()">
                  <v-icon left>mdi-plus-box-outline</v-icon> TAMBAH KOMODITAS
                </v-btn>
              </v-col>
              <v-col cols="12" md="3">
                <v-autocomplete
                  v-model="filterKecamatan"
                  :items="kecamatanOptions"
                  item-text="nama_kecamatan"
                  item-value="id"
                  label="Filter per Kecamatan"
                  clearable
                  solo-inverted
                  hide-details
                  prepend-inner-icon="mdi-map-marker-outline"
                  class="cyber-search"
                  placeholder="Cari & pilih kecamatan..."
                  no-data-text="Kecamatan tidak ditemukan"
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-autocomplete
                  v-model="filterJenis"
                  :items="jenisKomoditasOptions"
                  label="Filter per Jenis Komoditas"
                  clearable
                  solo-inverted
                  hide-details
                  prepend-inner-icon="mdi-filter-variant"
                  class="cyber-search"
                  placeholder="Cari & pilih jenis..."
                  no-data-text="Jenis tidak ditemukan"
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-database-search"
                  label="Cari Kategori Produksi..."
                  single-line
                  hide-details
                  flat
                  solo-inverted
                  class="cyber-search"
                />
              </v-col>
            </v-row>

            <v-data-table
              :headers="headers"
              :items="filteredKomoditas"
              :loading="loading"
              class="transparent-table"
            >
              <template v-slot:item.nama_kecamatan="{ item }">
                <span class="white--text font-weight-bold text-uppercase">{{
                  item.nama_kecamatan
                }}</span>
              </template>

              <template v-slot:item.jenis_komoditas="{ item }">
                <v-chip small outlined color="#018C74" class="font-weight-medium">
                  {{ item.jenis_komoditas }}
                </v-chip>
              </template>

              <template v-slot:item.kategori_produksi="{ item }">
                <v-chip small outlined color="#CFA22D" class="font-weight-medium">
                  {{ item.kategori_produksi }}
                </v-chip>
              </template>

              <template v-slot:item.actions="{ item }">
                <v-btn
                  icon
                  color="#018C74"
                  @click="openDialog(item)"
                  class="mx-1 glow-hover"
                >
                  <v-icon small>mdi-lead-pencil</v-icon>
                </v-btn>
                <v-btn
                  icon
                  color="#ff5252"
                  @click="deleteItem(item)"
                  class="mx-1 glow-hover"
                >
                  <v-icon small>mdi-delete-variant</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </base-material-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" max-width="600px" persistent overlay-opacity="0.85">
      <v-card class="cyber-dialog">
        <v-card-title class="dialog-header">
          <v-icon left color="#CFA22D">mdi-form-select</v-icon>
          <span class="font-weight-bold white--text">{{ formTitle.toUpperCase() }}</span>
          <v-spacer />
          <v-btn icon @click="close" small ><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text class="pt-8 px-6">
          <v-autocomplete
            v-model="editedItem.id_kecamatan"
            :items="kecamatanOptions"
            item-text="nama_kecamatan"
            item-value="id"
            label="Kecamatan"
            outlined
            color="#018C74"
            prepend-inner-icon="mdi-map-marker"
            class="cyber-input"
            clearable
            placeholder="Pilih kecamatan..."
            no-data-text="Kecamatan tidak ditemukan"
          />

          <v-combobox
            v-model="editedItem.jenis_komoditas"
            :items="jenisKomoditasOptions"
            :search-input.sync="searchJenis"
            label="Jenis Komoditas"
            outlined
            color="#018C74"
            prepend-inner-icon="mdi-corn"
            class="cyber-input"
            clearable
            placeholder="Contoh: Kopi, Tebu, Tembakau..."
            hint="Pilih yang tersedia, atau ketik jenis baru lalu tekan Enter"
            persistent-hint
            @keydown.enter.prevent.stop="addCustomJenis"
            @blur="addCustomJenis"
          >
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="caption text-uppercase yellow--text">
                    Tekan <kbd>Enter</kbd> untuk membuat jenis komoditas baru:
                    <strong>"{{ searchJenis }}"</strong>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-combobox>

          <v-combobox
            v-model="editedItem.kategori_produksi"
            :items="filteredKategoriOptions"
            :search-input.sync="searchKategori"
            label="Kategori Produksi"
            outlined
            color="#018C74"
            prepend-inner-icon="mdi-format-list-bulleted"
            class="cyber-input"
            clearable
            placeholder="Contoh: Kopi Arabika Rakyat / Perhutani..."
            hint="Pilih yang tersedia, atau ketik kategori baru lalu tekan Enter"
            persistent-hint
            @keydown.enter.prevent.stop="addCustomKategori"
            @blur="addCustomKategori"
          >
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="caption text-uppercase yellow--text">
                    Tekan <kbd>Enter</kbd> untuk membuat kategori produksi baru:
                    <strong>"{{ searchKategori }}"</strong>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-combobox>
        </v-card-text>

        <v-card-actions class="pa-6">
          <v-btn text @click="close" class="white--text opacity-6">BATAL</v-btn>
          <v-spacer></v-spacer>
          <v-btn class="cyber-btn-save" :loading="loading" @click="save"
            >SIMPAN DATA</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
const BASE_URL = "https://berkah.bondowosokab.go.id:5500";

export default {
  data: () => ({
    search: "",
    searchJenis: "",
    searchKategori: "",
    filterKecamatan: null,
    filterJenis: null,
    loading: false,
    dialog: false,
    komoditasList: [],
    kecamatanOptions: [],
    jenisKomoditasOptions: [],
    headers: [
      { text: "KECAMATAN", value: "nama_kecamatan" },
      { text: "JENIS KOMODITAS", value: "jenis_komoditas" },
      { text: "KATEGORI PRODUKSI", value: "kategori_produksi" },
      { text: "AKSI", value: "actions", sortable: false, align: "end" },
    ],
    editedIndex: -1,
    editedItem: {
      id: null,
      id_kecamatan: null,
      jenis_komoditas: "",
      kategori_produksi: "",
    },
    defaultItem: {
      id: null,
      id_kecamatan: null,
      jenis_komoditas: "",
      kategori_produksi: "",
    },
  }),

  computed: {
    filteredKomoditas() {
      let list = this.komoditasList;

      if (this.filterKecamatan) {
        list = list.filter((item) => item.id_kecamatan == this.filterKecamatan);
      }
      if (this.filterJenis) {
        list = list.filter((item) => item.jenis_komoditas === this.filterJenis);
      }
      if (this.search) {
        const query = this.search.toLowerCase();
        list = list.filter(
          (item) =>
            item.kategori_produksi && item.kategori_produksi.toLowerCase().includes(query)
        );
      }
      return list;
    },

    filteredKategoriOptions() {
      if (!this.editedItem.jenis_komoditas) return [];
      const unik = new Set();
      this.komoditasList.forEach((item) => {
        if (
          item.jenis_komoditas === this.editedItem.jenis_komoditas &&
          item.kategori_produksi
        ) {
          unik.add(item.kategori_produksi);
        }
      });
      return Array.from(unik).sort();
    },

    formTitle() {
      return this.editedIndex === -1
        ? "Tambah Produksi Komoditas"
        : "Edit Produksi Komoditas";
    },
  },

  mounted() {
    this.fetchKecamatanOptions();
    this.fetchJenisKomoditasOptions();
    this.fetchData();
  },

  methods: {
    async fetchData() {
      this.loading = true;
      try {
        const res = await axios.get(`${BASE_URL}/master/produksi-komoditas`);
        if (res.data && res.data.response) {
          this.komoditasList = res.data.response.data || [];
        }
      } catch (e) {
        console.error("Gagal load produksi komoditas:", e);
      } finally {
        this.loading = false;
      }
    },

    async fetchKecamatanOptions() {
      try {
        const res = await axios.get(`${BASE_URL}/master/produksi-komoditas/kecamatan`);
        if (res.data && res.data.response) {
          this.kecamatanOptions = res.data.response.data || [];
        }
      } catch (e) {
        console.error("Gagal load opsi kecamatan:", e);
      }
    },

    async fetchJenisKomoditasOptions() {
      try {
        const res = await axios.get(`${BASE_URL}/master/produksi-komoditas/jenis`);
        if (res.data && res.data.response) {
          this.jenisKomoditasOptions = res.data.response.data || [];
        }
      } catch (e) {
        console.error("Gagal load opsi jenis komoditas, pakai fallback dari data:", e);
        const unik = new Set();
        this.komoditasList.forEach((item) => {
          if (item.jenis_komoditas) unik.add(item.jenis_komoditas);
        });
        this.jenisKomoditasOptions = Array.from(unik).sort();
      }
    },

    addCustomJenis() {
      const value = this.normalizeText(
        this.searchJenis || this.editedItem.jenis_komoditas
      );
      if (!value) return;

      this.editedItem.jenis_komoditas = value;

      if (!this.jenisKomoditasOptions.includes(value)) {
        this.jenisKomoditasOptions.push(value);
        this.jenisKomoditasOptions = [...this.jenisKomoditasOptions].sort();
      }

      this.searchJenis = value;
    },

    addCustomKategori() {
      const value = this.normalizeText(
        this.searchKategori || this.editedItem.kategori_produksi
      );
      if (!value) return;

      this.editedItem.kategori_produksi = value;

      this.searchKategori = value;
    },

    openDialog(item) {
      this.editedIndex = item ? this.komoditasList.indexOf(item) : -1;

      if (item) {
        this.editedItem = Object.assign({}, item);
      } else {
        this.editedItem = Object.assign({}, this.defaultItem);
      }
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.searchJenis = "";
        this.searchKategori = "";
      });
    },

    normalizeText(val) {
      if (val === null || val === undefined) return "";
      return String(val).trim();
    },

    commitComboboxValues() {
      const jenis = this.normalizeText(this.searchJenis);
      const kategori = this.normalizeText(this.searchKategori);

      if (jenis) {
        this.editedItem.jenis_komoditas = jenis;
        if (!this.jenisKomoditasOptions.includes(jenis)) {
          this.jenisKomoditasOptions.push(jenis);
          this.jenisKomoditasOptions = [...this.jenisKomoditasOptions].sort();
        }
      }

      if (kategori) {
        this.editedItem.kategori_produksi = kategori;
      }

      this.editedItem.jenis_komoditas = this.normalizeText(
        this.editedItem.jenis_komoditas
      );
      this.editedItem.kategori_produksi = this.normalizeText(
        this.editedItem.kategori_produksi
      );
    },

    async save() {
      this.commitComboboxValues();

      if (
        !this.editedItem.id_kecamatan ||
        !this.editedItem.jenis_komoditas ||
        !this.editedItem.kategori_produksi
      ) {
        return alert("Kecamatan, Jenis Komoditas, dan Kategori Produksi wajib diisi!");
      }

      this.loading = true;
      try {
        const payload = {
          id_kecamatan: this.editedItem.id_kecamatan,
          jenis_komoditas: this.normalizeText(this.editedItem.jenis_komoditas),
          kategori_produksi: this.normalizeText(this.editedItem.kategori_produksi),
        };

        if (this.editedIndex > -1) {
          await axios.put(
            `${BASE_URL}/master/produksi-komoditas/${this.editedItem.id}`,
            payload
          );
        } else {
          await axios.post(`${BASE_URL}/master/produksi-komoditas`, payload);
        }

        await this.fetchData();
        await this.fetchJenisKomoditasOptions();
        this.close();
      } catch (e) {
        console.error("Gagal menyimpan data produksi komoditas:", e);
        alert("Gagal menyimpan data produksi komoditas");
      } finally {
        this.loading = false;
      }
    },

    async deleteItem(item) {
      if (
        confirm(
          `Hapus data produksi "${item.jenis_komoditas} - ${item.kategori_produksi}" di kecamatan ini?`
        )
      ) {
        try {
          await axios.delete(`${BASE_URL}/master/produksi-komoditas/${item.id}`);
          this.fetchData();
        } catch (e) {
          alert("Gagal menghapus");
        }
      }
    },
  },
};
</script>

<style scoped>
.cyber-container {
  background: transparent;
}
.cyber-title {
  letter-spacing: 3px !important;
  text-shadow: 0 0 12px rgba(1, 140, 116, 0.4);
  color: white !important;
}
.secondary-text {
  color: #cfa22d !important;
}
.opacity-6 {
  opacity: 0.6;
}
.glass-card {
  background: rgba(0, 26, 22, 0.8) !important;
  backdrop-filter: blur(12px);
  border: 1px solid rgba(1, 140, 116, 0.3) !important;
}
.transparent-table {
  background: transparent !important;
}
.transparent-table >>> th {
  color: #cfa22d !important;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  border-bottom: 2px solid #018c74 !important;
}
.cyber-btn-add {
  background: linear-gradient(45deg, #018c74, #004d40) !important;
  color: white !important;
  border: 1px solid #cfa22d !important;
  font-weight: 900;
  box-shadow: 0 0 15px rgba(1, 140, 116, 0.3) !important;
}
.cyber-btn-save {
  background-color: #cfa22d !important;
  color: #002616 !important;
  font-weight: 900 !important;
}
.glow-hover:hover {
  filter: drop-shadow(0 0 5px currentColor);
}
.cyber-dialog {
  background: rgba(0, 20, 18, 0.96) !important;
  border: 1px solid #018c74 !important;
}
.dialog-header {
  border-bottom: 1px solid rgba(1, 140, 116, 0.3);
  background: rgba(1, 140, 116, 0.1);
}

.cyber-page,
.cyber-container,
.cyber-portal {
  background: transparent !important;
}

.cyber-title,
.cyber-text,
.cyber-id,
.cyber-desc,
.cyber-item-text {
  color: #1c2b28 !important;
  text-shadow: none !important;
}

.secondary-text {
  color: #018c74 !important;
  text-shadow: none !important;
}

.glass-card,
.cyber-card,
.cyber-dialog,
.cyber-dialog-card,
.cyber-modal,
.cyber-map-container,
.cyber-mapping-container,
.cyber-news-container,
.cyber-moments,
.cyber-carousel,
.cyber-agenda,
.cyber-sosmed-header,
.cyber-map-box,
.cyber-map {
  background: #ffffff !important;
  border: 1px solid #eef1f0 !important;
  backdrop-filter: none !important;
  color: #1c2b28 !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04) !important;
}

.dialog-header,
.dialog-header-gradient {
  background: #f4f7f6 !important;
  color: #1c2b28 !important;
  border-bottom: 1px solid #eef1f0 !important;
}

.dialog-header .white--text,
.dialog-header-gradient .white--text,
.cyber-dialog .white--text,
.cyber-dialog-card .white--text {
  color: #1c2b28 !important;
}

.dialog-neon-line,
.neon-line {
  background: linear-gradient(90deg, #018c74, #cfa22d, #018c74) !important;
}

.transparent-table,
.cyber-table,
.transparent-tabs {
  background: #ffffff !important;
  color: #1c2b28 !important;
}

.transparent-table >>> th,
.cyber-table >>> th {
  background: #f4f7f6 !important;
  color: #018c74 !important;
  font-weight: 800;
  border-bottom: 2px solid #018c74 !important;
}

.transparent-table >>> td,
.cyber-table >>> td {
  color: #1c2b28 !important;
  border-bottom: 1px solid #eef1f0 !important;
}

.transparent-table >>> .v-data-table__empty-wrapper,
.cyber-table >>> .v-data-table__empty-wrapper {
  color: #9aa6a3 !important;
}

.cyber-input,
.cyber-field,
.cyber-search,
.cyber-search-field,
.cyber-search-bar,
.cyber-input-mini,
.cyber-input-dense,
.cyber-input-highlight,
.cyber-input-coord,
.cyber-coord-field,
.cyber-select-dense,
.cyber-file-input,
.cyber-datepicker {
  color: #1c2b28 !important;
}

.cyber-input >>> .v-input__control,
.cyber-field >>> .v-input__control,
.cyber-search >>> .v-input__control,
.cyber-search-field >>> .v-input__control,
.cyber-search-bar >>> .v-input__control,
.cyber-input-mini >>> .v-input__control,
.cyber-input-dense >>> .v-input__control,
.cyber-input-highlight >>> .v-input__control,
.cyber-input-coord >>> .v-input__control,
.cyber-coord-field >>> .v-input__control,
.cyber-select-dense >>> .v-input__control,
.cyber-file-input >>> .v-input__control,
.cyber-datepicker >>> .v-input__control {
  background: #ffffff !important;
  border-radius: 10px;
}

.cyber-input >>> input,
.cyber-field >>> input,
.cyber-search >>> input,
.cyber-search-field >>> input,
.cyber-search-bar >>> input,
.cyber-input-mini >>> input,
.cyber-input-dense >>> input,
.cyber-input-coord >>> input,
.cyber-coord-field >>> input,
.cyber-datepicker >>> input,
.cyber-input >>> .v-label,
.cyber-field >>> .v-label,
.cyber-search >>> .v-label,
.cyber-search-field >>> .v-label,
.cyber-search-bar >>> .v-label,
.cyber-select-dense >>> .v-label,
.cyber-datepicker >>> .v-label {
  color: #1c2b28 !important;
}

.cyber-btn-add,
.cyber-add-btn,
.cyber-add-sosmed-btn {
  background: linear-gradient(135deg, #018c74 0%, #02b395 100%) !important;
  color: #ffffff !important;
  font-weight: 700;
  border: none !important;
  box-shadow: 0 8px 20px rgba(1, 140, 116, 0.25) !important;
}

.cyber-btn-save,
.cyber-save-btn {
  background: #018c74 !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  box-shadow: 0 8px 20px rgba(1, 140, 116, 0.25) !important;
}

.icon-scan-box,
.icon-scan-frame,
.preview-container,
.preview-hex-frame,
.preview-mini-frame,
.preview-scanner {
  background: #f4f7f6 !important;
  border: 1px solid #eef1f0 !important;
}

.preview-tag {
  background: #eaf6f3 !important;
  color: #018c74 !important;
  border: 1px solid rgba(1, 140, 116, 0.3) !important;
}

.scan-overlay {
  display: none !important;
}

.shadow-glow,
.shadow-glow-gold,
.shadow-glow-teal {
  box-shadow: 0 6px 16px rgba(1, 140, 116, 0.15) !important;
}

.action-glow.edit-btn,
.action-glow.delete-btn {
  background: transparent !important;
}


.v-data-table >>> .white--text {
  color: #1c2b28 !important;
}
.plain-description {
  color: #4a5a57 !important;
}

</style>
